import dynamic from 'next/dynamic';

const Filters = dynamic(() => import('./index').then((component) => ({default: component.Filters})), {
    loading: () => null,
});

export {Filters};
